import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    NgModule,
} from '@angular/core';
import { Cms } from '@impact/data';
import { OverlayService } from '@impactdk/ngx-overlay';
import { TranslateModule } from '@ngx-translate/core';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { BookWorkshopStepperComponent } from './book-workshop-stepper.component';
import { BookWorkshopModule } from './book-workshop.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-book-workshop-page',
    template: `
        <section class="layout-wrapper book-workshop-page">
            <app-rich-text
                *ngIf="data.introduction"
                [html]="data.introduction"
            ></app-rich-text>

            <button
                class="book-workshop-page__button button button--primary"
                (click)="startWorkshopBooking()"
                [innerText]="'book_workshop.start_workshop_booking' | translate"
            ></button>
        </section>
    `,
})
class BookWorkshopPageComponent {
    @Input() data: Cms.BookWorkshopPage;

    constructor(private overlayService: OverlayService) {}

    startWorkshopBooking() {
        this.overlayService.open(BookWorkshopStepperComponent, {
            panelClass: 'full-page-takeover',
            fullHeight: true,
            data: {
                pageContent: this.data,
            },
        });
    }
}

@NgModule({
    declarations: [BookWorkshopPageComponent],
    imports: [
        BookWorkshopModule,
        CommonModule,
        RichTextModule,
        TranslateModule.forChild(),
    ],
})
class BookWorkshopPageModule {}

export const LazyComponent = BookWorkshopPageComponent;
